const DEBUG = false;

export default class QuickSearch {

    private _searchValue?       : string         // used to do quick search
    private onChange            : callback

    constructor(onChange:callback) {
        this.onChange = onChange
    }

    public reset():void {
        this.searchValue = undefined
    }

    set searchValue(value) {

        if (value===this._searchValue) {
            // same value - ignore
            return
        }

        this._searchValue = value ? value.toLowerCase() : undefined;

        this.onChange()
    }

    get searchValue() {
        return this._searchValue
    }

    get enabled() {
        return !!this.searchValue
    }

    get searchValueNormalized():string {

        if (this._searchValue) return this._searchValue?.toLowerCase().trim()
        else return "impossible-quick-search"

    }



}